<div class="dialog-container">
  <div class="dialog-title" mat-dialog-title>
    <ng-content select="[title]"></ng-content>
    @if (!noCloseIcon()) {
      <div class="flex">
        <app-icon name="heroXMark" size="small" class="text-gray-400 cursor-pointer" mat-dialog-close></app-icon>
      </div>
    }
  </div>

  <div class="second-title">
    <ng-content select="[secondTitle]"></ng-content>
  </div>

  <div class="sub-title">
    <ng-content select="[subtitle]"></ng-content>
  </div>

  <div class="dialog-content">
    <mat-dialog-content>
      <ng-content></ng-content>
    </mat-dialog-content>
  </div>

  @if (!noActions()) {
  <mat-dialog-actions class="dialog-footer">
    <ng-content select="[footer]"></ng-content>
  </mat-dialog-actions>
  }
</div>
